import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_62: FaireProductEntity = {
  token: "catalog_prod_prod-62",
  type: "product",
  name: "Linen Table Runner - Natural - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 72.61,
  msrpDollars: 181.53,
  sku: "JA0062",
  caseSize: 4,
  material: "Linen",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 198,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_crafts-hobbies"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
